<template>
  <div
    id="app"
    class="blu"
  >
    <div>
      <div class="sentinal" />
      <Header
        :class="headerClass"
        :is-sticky="isSticky"
        @updateStickyHeader="updateStickyHeader"
      />
      <router-view />
      <template v-if="currentRouteName !== 'Details'">
        <template v-if="checkFooterDisplay">
          <FooterDetails />
        </template>
        <Footer />
      </template>
      <Loader v-if="loader" />
    </div>
  </div>
</template>

<script src="./js/app.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';

.blu {
  background-color: #FFFFFF80;
}

</style>
